import { jsx, jsxs } from 'react/jsx-runtime';
import { useState, useRef } from 'react';
import { twMerge } from '@belong/common/twMerge';
import { useRect } from '@reach/rect';
import { TabPanels, TabPanel, Tabs as Tabs$1, TabsOrientation } from '@reach/tabs';
import { ActiveTabIndicator } from './ActiveTabIndicator.js';
import { AnimationContext } from './AnimationContext.js';
import { Item } from './Item.js';
import { List } from './List.js';
import css from './Tabs.module.css.js';

Tabs.TabList = List;
Tabs.TabItem = Item;
Tabs.PanelList = TabPanels;
Tabs.PanelItem = TabPanel;
// The animation logic was taken from https://reach.tech/tabs.
function Tabs({
  defaultIndex = 0,
  isDraggable = false,
  hasBlurOnScroll = true,
  activeColor = 'bg-navy',
  children,
  onChange,
  className,
  activeClassname,
  ...props
}) {
  // Store the position we want to animate to
  const [activeRect, setActiveRect] = useState(null);
  const ref = useRef(null);
  const rect = useRect(ref);
  return jsx("div", {
    className: twMerge(css.tab, hasBlurOnScroll ? css.tab : css.tabWithoutBlur, isDraggable ? css.draggableContainer : css.container, className),
    children: jsx(AnimationContext.Provider, {
      value: {
        isDraggable,
        setActiveRect
      },
      children: jsxs(Tabs$1, {
        ...props,
        className: "relative",
        defaultIndex: defaultIndex,
        onChange: onChange,
        orientation: TabsOrientation.Horizontal,
        ref: ref,
        children: [jsx("div", {
          className: twMerge('absolute overflow-hidden h-3xl flex flex-col top-0 left-0 w-full', activeClassname),
          children: jsx(ActiveTabIndicator, {
            activeRect: activeRect,
            rect: rect,
            color: activeColor
          })
        }), children]
      })
    })
  });
}

export { Tabs };
